export {parseTime, formatTime} from '@/utils';

/**
 * 企业经营状态
 */
export function companyOperationStateName (number) {
  if (number === 5 || number === '5') {
    return '存续';
  } else if (number === 7 || number === '7') {
    return '在业';
  } else if (number === 4 || number === '4') {
    return '吊销';
  } else if (number === 0 || number === '0') {
    return '注销';
  } else if (number === 1 || number === '1') {
    return '撤销';
  } else if (number === 6 || number === '6') {
    return '迁出';
  } else if (number === 2 || number === '2') {
    return '停业';
  } else if (number === 8 || number === '8') {
    return '已告解散';
  } else if (number === 3 || number === '3') {
    return '其他';
  } else {
    return '';
  }
}

/**
 * 综合实力评级
 */
export function comprehensiveStrengthGradeName (number) {
  if (number === 0 || number === '0') {
    return 'A';
  } else if (number === 1 || number === '1') {
    return 'B';
  } else if (number === 2 || number === '2') {
    return 'C';
  } else if (number === 3 || number === '3') {
    return 'D';
  } else if (number === 4 || number === '4') {
    return 'E';
  } else {
    return '——';
  }
}

/**
 * 融资类型
 */
export function financingName (number) {
  if (number === 0 || number === '0') {
    return '种子轮';
  } else if (number === 1 || number === '1') {
    return '天使轮';
  } else if (number === 2 || number === '2') {
    return 'A轮';
  } else if (number === 3 || number === '3') {
    return 'B轮';
  } else if (number === 4 || number === '4') {
    return 'C轮';
  } else if (number === 5 || number === '5') {
    return 'D轮';
  } else if (number === 6 || number === '6') {
    return 'E轮～Pre-IPO';
  } else if (number === 7 || number === '7') {
    return '战略投资';
  } else if (number === 8 || number === '8') {
    return '并购';
  } else if (number === 9 || number === '9') {
    return '新三板';
  } else if (number === 10 || number === '10') {
    return 'IPO上市及以后';
  } else if (number === 11 || number === '11') {
    return '退市';
  } else if (number === 99 || number === '99') {
    return '其他轮次';
  } else {
    return '——';
  }
}

/**
 * 专利类型
 */
export function patentTypeName (number) {
  if (number === 0 || number === '0') {
    return '发明';
  } else if (number === 1 || number === '1') {
    return '实用新型';
  } else if (number === 2 || number === '2') {
    return '外观';
  } else {
    return '';
  }
}

/**
 * 专利法律状态
 */
export function patentLegalState (number) {
  if (number === 0 || number === '0') {
    return '在审';
  } else if (number === 1 || number === '1') {
    return '授权';
  } else if (number === 2 || number === '2') {
    return '失效';
  } else {
    return '';
  }
}

export function amountTenThousand (num, type) {
  if (num) {
    return (num / 10000).toLocaleString() + '万' + currencyName(type);
  } else {
    return '未披露';
  }
}

/**
 * 货币类型
 */
export function currencyName (type) {
  if (type === 'CNY') {
    return '人民币';
  } else if (type === 'USD') {
    return '美元';
  } else if (type === 'HKD') {
    return '港元';
  } else if (type === 'EUR') {
    return '欧元';
  } else if (type === 'JPY') {
    return '日元';
  } else if (type === 'AFN') {
    return '阿富汗尼';
  } else if (type === 'AUD') {
    return '澳大利亚元';
  } else if (type === 'FRF') {
    return '法国法郎';
  } else if (type === 'CAD') {
    return '加元';
  } else if (type === 'DEM') {
    return '德国马克';
  } else if (type === 'CLP') {
    return '智利比索';
  } else if (type === 'SGD') {
    return '新加坡元';
  } else if (type === 'GBP') {
    return '英镑';
  } else if (type === 'CHF') {
    return '瑞士法郎';
  } else if (type === 'DKK') {
    return '丹麦克朗';
  } else if (type === 'MOP') {
    return '澳门币';
  } else {
    return '';
  }
}

/**
 * 证书状态
 */
export function certificateStatus (number) {
  if (number === 1 || number === '1') {
    return '有效';
  } else if (number === 2 || number === '2') {
    return '注销';
  } else if (number === 3 || number === '3') {
    return '过期';
  } else if (number === 4 || number === '4') {
    return '暂停';
  } else if (number === 5 || number === '5') {
    return '撤销';
  } else if (number === 6 || number === '6') {
    return '失效';
  } else if (number === 7 || number === '7') {
    return '未知';
  } else {
    return '——';
  }
}

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize (time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}

/**
 * @param {number} time
 */
export function timeAgo (time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter (num, digits) {
  const si = [
    {value: 1E18, symbol: 'E'},
    {value: 1E15, symbol: 'P'},
    {value: 1E12, symbol: 'T'},
    {value: 1E9, symbol: 'G'},
    {value: 1E6, symbol: 'M'},
    {value: 1E3, symbol: 'k'}
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
    }
  }
  return num.toString();
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter (num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
}

/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst (string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * 获取枚举值,list格式：[{label:'名称',value:'值'}]
 * @param value {Object}
 * @param list {Array}
 * @returns {string|*}
 */
export function getText (value, list) {
  if (value == null || value === '') {
    return '';
  }

  for (let i = 0; i < list.length; i++) {
    if (String(value) === String(list[i].value)) {
      return list[i].text;
    }
  }
}

/**
 * 字段值
 */
export function getDictName (value, arr) {
  if (value === undefined) return '';
  let name = '';
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].value == value) {
      name = arr[i].text;
    }
  }
  return name;
}



// WEBPACK FOOTER //
// ./src/filters/index.js